import { RosterRequestQuery } from 'generated/graphql';
import { useAppSelector } from 'store/store';
import getEnumLabel from 'utilities/getEnumLabel';

type TypeProps = {
  request: RosterRequestQuery['rosterRequest'];
};

const RequestType = ({ request }: TypeProps) => {
  const { rosterRequestType } = useAppSelector((state) => state.enums);

  return (
    <>Request Type: {getEnumLabel(rosterRequestType, request.requestType)}</>
  );
};

export default RequestType;
